;
define("global_views_star_rating.tpl", function(){});

